import { Pipe, PipeTransform } from "@angular/core";
import { viLocale } from "@node_modules/ngx-bootstrap/chronos";
import * as moment from "moment";

@Pipe({ name: "momentPipe" })
export class MomentPipe implements PipeTransform {
  transform(value: Date | moment.Moment, dateFormat?: string | undefined): any {
    const format = dateFormat ? dateFormat : "dddd, Do MMMM  YYYY, hh:mm a";

    if (value)
      return moment(value).format(format);
    else
      return "N/A";
  }
}
